export const FontFaces = `
    @font-face {
        font-family: 'e-icons';
        font-style: normal;
        font-weight: normal;
        src: url('./assets/fonts/e-icons/e-icons.ttf') format('truetype');
    }
`;